import { UploadFileLocal } from "shared/components/upload-file/upload-file";
import { ThemeTemplateItem } from "states/theme-template/theme-template.models";

export interface IThemeSettingImageListProps {
  model: any;
  template: ThemeTemplateItem;
  onChange: (changedModel: any) => void;
}

export function ThemeSettingImageList(props: IThemeSettingImageListProps) {
  const { model, template, onChange } = props;
  return (
    <div className="theme-image-item">
      <div className="pb-2">
        <b>{template.name}</b>
      </div>
      <UploadFileLocal
        album={model ? model : []}
        multiple
        isUploadModal={true}
        onChange={(newFileList: string[]) => {
          onChange([...newFileList]);
        }}
      />
    </div>
  );
}
